@reference "@glow/tailwind-config/reference.css";

.tabList {
  @apply flex;
  @apply border-0;
  @apply border-b-2;
  @apply border-emphasis-low;
  @apply border-solid;
  @apply whitespace-nowrap;
}

.tabList li {
  @apply list-none;
}

.stick-to-top {
  @apply sticky;
  @apply top-0;
  @apply z-10;
  @apply bg-white;
}
.tabItem a {
  @apply flex;
  @apply gap-2;
  @apply items-center;
  @apply text-gray-600;
  @apply text-sm;
  @apply cursor-pointer;
  @apply -mb-[2px];
  @apply p-2;
  @apply sm:px-4;
  @apply sm:py-3;
  @apply border-solid;
  @apply no-underline;
  @apply border-0;
  @apply border-b-2;
  @apply border-emphasis-low;
}

.tabItem a:hover {
  @apply text-emphasis-high;
  @apply border-emphasis-medium;
}

.tabItem a[aria-current="page"] {
  @apply text-emphasis-extra;
  @apply font-semibold;
  @apply border-emphasis-extra;
}
.tabItem a[data-selected="true"] {
  @apply text-emphasis-extra;
  @apply font-semibold;
  @apply border-emphasis-extra;
}

.tabItem svg {
  @apply text-base;
}
